{
  "Description": "3-Digits - NNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{3}$",
  "TestData": {
    "Valid": [
      "123",
      "567"
    ],
    "Invalid": [
      "1234",
      "13s",
      "1x3"
    ]
  }
}
